import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { auth } from "../firebase";
import { syncUserListener } from "../features/auth/auth.listener";
import { updateUserLanguage } from "../features/auth/auth.service";
import { setUserLogged } from "../features/auth/auth.slice";

export const useCentralizedUserListener = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    const unsubscribeAuth = auth.onAuthStateChanged(async (user) => {
      console.log(`onAuthStateChanged ${user?.uid}`);
      if (!user) {
        dispatch(setUserLogged(false));
        await auth.signInAnonymously();
        return;
      }

      if (!user.isAnonymous) {
        await updateUserLanguage(user.uid);
      }
      syncUserListener(user.uid, dispatch);
      dispatch(setUserLogged(true));
    });

    return () => {
      unsubscribeAuth();
      syncUserListener(null, dispatch);
    };
  }, [dispatch]);
};